<template>
  <div>
    <v-row>
      <v-col cols="12" lg="6" offset-lg="3">
        <v-card>
          <v-card-title>Login</v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field label="login" v-model="loginVm.login" @keydown.enter="login"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field label="hasło" v-model="loginVm.password" type="password" @keydown.enter="login"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="twoFactoryEnabled">
              <v-col>
                <v-text-field label="kod podwojnego potwierdzenia" v-model="loginVm.twoStepCode" @keydown.enter="login"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn color="primary" block @click="login">Zaloguj</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="invalidLoginDialog" width=600>
      <v-card color="red--text">
        <v-card-title>
          <v-icon class="mr-2 red--text">fa-exclamation-circle</v-icon>
          Błąd logowania
        </v-card-title>
        <v-card-text>Login lub hasło jest nieprawidłowe</v-card-text>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {showError} from "@/helpers";

export default {
  data() {
    return {
      loginVm: {
        login: "",
        password: "",
        twoStepCode: ""
      },
      invalidLoginDialog: false,
      twoFactoryEnabled: false
    };
  },
  methods: {
    async login() {
      try{
        const response = await this.$http.post("/Authentication/Login", this.loginVm)
      
        this.$store.dispatch("login", response.data.token);
      }
      catch (error){
        if (error.response.status === 400)
        {
          if (error.response.data == "User have setup two factory authentication") {
            this.twoFactoryEnabled = true
          }
          else if(error.response.data == "Wrong two step code"){
            showError("Nieprawidłowy kod weryfikacyjny")
          }
          else if(error.response.data == "User is disabled"){
            showError("Użytkownik został wyłączony")
          }
          else
          {
            showError("Nieprawidłowy login lub hasło")
          }
          //vm.invalidLoginDialog = true;
        }
        if (error.response.status === 429)
        {
          showError("Zbyt wiele prób zalogowania")
        }
      }
    }
  }
};
</script>
